<form [formGroup]="enforcerForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
    <div class="form-80">
        <h1 class="blue margin">{{title}}</h1>
        <p class="lead rocal">Add details of enforcer below or click on the&nbsp;<strong>Skip</strong>&nbsp;button below to skip.</p>

        <div class="flex godolkin" style="margin-top: 0px;">
            <div class="flex suggestions" *ngIf="suggestions !== null" [@bounceIn] #suggestBox>
                <div class="flex suggest">
                    Autofill
                </div>

                <div class="flex sugg-holder">
                    <div [@slideInRight] *ngFor="let suggestion of suggestions; let s=index"
                        (click)="patchSuggestedValues(suggestion)"
                        class="flex suggestion">
                        {{ suggestion.FirstName +' ' +suggestion.LastName }}
                    </div>
                </div>
            </div>
        </div>

        <div class="flex" style="width: 100%; align-items: center; justify-content: center; margin-bottom: 20px;">
            <div class="flex brief" *ngIf="suggestions === null && showSuggestHint"[@bounceIn]>
                If the Enforcer is also a Settlor, use the ID field to search and autofill their details
            </div>
        </div>

        <!-- Panel 1: Enforcer Info -->
        <ng-template #enforcerInfo let-i="index">
            <div>
                <div class="line-section"></div>

                <div class="row-alt">
                    <div class="row-mini">
                        <app-input [formGroup]="enforcerForm" controlName="Title"
                            label={{titleLabel}} hint={{titleHint}}
                            inputType="auto-complete" required='false'
                            [loadingOptions]="loadingTitles"
                            [ArrayItems]="TitleOptions"
                            [validationMessages]="validationMessages" [formErrors]="formErrors">
                        </app-input>

                        <app-input [formGroup]="enforcerForm" controlName="FirstName"
                            label={{fNameLabel}} hint={{fNameHint}}
                            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
                    </div>
                    
                    <div class="row-mini">
                        <app-input [formGroup]="enforcerForm" controlName="MiddleName"
                            label={{mNameLabel}} hint={{mNameHint}} required='false'
                            [validationMessages]="validationMessages" [formErrors]="formErrors" ></app-input>
                        <app-input [formGroup]="enforcerForm" controlName="LastName"
                            label={{surnameLabel}} hint={{surnameHint}}
                            [validationMessages]="validationMessages" [formErrors]="formErrors" ></app-input>
                    </div>
                    
                </div>

                <div class="row">
                    <app-input [formGroup]="enforcerForm" class="grid-item"
                        controlName="Phone" label={{phoneLabel}}  inputType="phone"
                        [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
                    <app-input [formGroup]="enforcerForm" class="grid-item"
                        controlName="Email" label={{emailLabel}} hint={{emailLabel}}
                        [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
                </div>

                <div class="row">
                    <app-input [formGroup]="enforcerForm" class="grid-item"
                        controlName="IDNo" label={{idLabel}} hint={{idHint}}
                        [runSuggestions]="true"
                        [altIDSuggest]="true"
                        [suggestID]="suggestSettlors.bind(this, i)"
                        [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
                    <app-input [formGroup]="enforcerForm" class="grid-item"
                      [required]="region == 1 ? 'false' : 'true' "
                      [subtext]="region == 1 ? 'KRA PIN is optional' : '' "
                        controlName="KraPin" label={{kraPinLabel}} hint={{kraHint}}
                        [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
                </div>

                <div class="row">
                    <app-input [formGroup]="enforcerForm" class="grid-item"
                        controlName="Address" label={{addressLabel}} hint={{addressHint}}
                        [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
                    <app-input [formGroup]="enforcerForm" class="grid-item"
                        controlName="Relationship"
                        inputType="select"
                        [selectFunction]="onRelationshipChange.bind(this)"
                        [ArrayItems]="Relationships"
                        label={{relationLabel}} hint={{relationHint}}
                        [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
                </div>   
                
                <div class="row half" *ngIf="enforcerForm.get('Relationship')?.value === 'Other'">
                    <app-input [formGroup]="enforcerForm" controlName="Other"
                        label='Specify Relationship' hint='Specify your relation to the settlor'
                        [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
                </div>
            </div>
        </ng-template>

        <!-- Panel 2: Upload Documents -->
        <ng-template #uploadDocs let-i="index">
            <div>
                <div class="line-section"></div>

                <div class="row">
                    <app-input [formGroup]="enforcerForm"
                        controlName="IDNoImage"
                        [fileFunction]="updateIDObject.bind(this)"
                        [existingFileName]="enforcer?.IDNoImage?.name != '' ? enforcer?.IDNoImage?.name :
                            enforcerForm.get('Relationship')?.value == 'Self' &&
                            recordUpdate?.IDNoImage != '' ? recordUpdate?.IDNoImage?.name : ''
                        "
                        class="grid-item" label={{idFileLabel}} hint={{idHint}} inputType="file"
                        [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
                    <app-input [formGroup]="enforcerForm" class="grid-item"
                        [required]="region == 1 ? 'false' : 'true' "
                        [subtext]="region == 1 ? 'KRA PIN is optional' : '' "
                        controlName="KraPinImage"
                        label={{kraFileLabel}} inputType="file"
                        [fileFunction]="updateKraObject.bind(this)"
                        [existingFileName]="enforcer?.KraPinImage?.name != '' ? enforcer?.KraPinImage?.name :
                            enforcerForm.get('Relationship')?.value == 'Self' &&
                            recordUpdate.KraPinImage != '' ? recordUpdate.KraPinImage.name : ''
                        "
                        [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
                </div>
            </div>
        </ng-template>

        <!-- Accordion -->
        <app-section [panels]="enforcerPanel[0]" style="display: flex; box-sizing: border-box;">
        </app-section>

        <div class="flex align width-100"
            style="justify-content: space-between; flex-direction: row-reverse; margin-top: 16px;">
            <div class="flex center reset-button" (click)="resetForm()" *ngIf="enforcerForm.touched && !enforcer.verified">
                <mat-icon style="margin-right: 10px;" fontIcon="clear_all" aria-hidden="false" aria-label="reset form"></mat-icon>
                {{ 'Reset Form' }}
            </div>

            <button mat-stroked-button type="button" class="remove-solo" (click)="removeEnforcer()" *ngIf="enforcer.verified">
                <div style="display: flex; flex: 1; align-items: center;">
                    <span class="button-text">
                        <u>Remove Enforcer</u>
                    </span>
                    <span class="spinning-global" *ngIf="loadingRemove">
                        <mat-progress-spinner mode="indeterminate" diameter="25" strokeWidth="4">
                        </mat-progress-spinner>
                    </span>
                </div>
            </button>
        </div>

    </div>

    <!-- BOTTOM OF FORM -->
    <app-form-bottom style="width: 100%;"
        [service]="estateControlService"
        [text]="loading ? loadingText :
            enforcer.done ? (confirmFormMatchesRecord() ? 'Next' : 'Update Details') :
            enforcer.verified ? 'Upload Documents' :
            enforcerForm.touched ? 'Save Details' : 'Skip'
        "
        [showContinue]="enforcerForm.touched ? (enforcerForm.valid || enforcer.done ? 'true' : 'false') : 'true'"
        [saveFunction]="updateProgress.bind(this)"
        [formValid]="(!enforcerForm.touched && !enforcer.verified) ? true : enforcerForm.valid"
        [buttonClickHandler]="submitForm.bind(this)">
    </app-form-bottom>
</form>
